export const popoverConstants = {
    ADD_POPOVER: 'ADD_POPOVER',
    REMOVE_POPOVER: 'REMOVE_POPOVER',
    CLEAR_ALL: 'CLEAR_ALL',
}